import React from "react";

const TriggerRow = ({ label, checked, onChange, disabled }) => (
  <div className="flex items-center justify-between text-xs text-jp-ink">
    <span className={disabled ? 'opacity-50' : ''}>{label}</span>
    <label className={`relative inline-flex items-center ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
      <input
        type="checkbox"
        className="sr-only peer"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <div className={`w-10 h-5 bg-jp-section rounded-full peer peer-checked:bg-sky-500 transition-colors ${disabled ? 'opacity-50' : ''}`} />
      <div className="absolute left-0.5 top-0.5 w-4 h-4 bg-white rounded-full shadow transform peer-checked:translate-x-5 transition-transform" />
    </label>
  </div>
);

export const NotificationTriggers = ({ triggers, onToggle, loading }) => (
  <div>
    <div className="flex items-center justify-between mb-3">
      <h3 className="text-xs font-semibold text-jp-ink text-left">TRIGGERS</h3>
      {loading && (
        <div className="w-4 h-4 border-2 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
      )}
    </div>
    <div className="space-y-3">
      <TriggerRow
        label="Player Registration"
        checked={triggers.playerRegistration}
        onChange={() => onToggle("playerRegistration")}
        disabled={loading}
      />
      <TriggerRow
        label="Player Profile Claim"
        checked={triggers.playerProfileClaim}
        onChange={() => onToggle("playerProfileClaim")}
        disabled={loading}
      />
      <TriggerRow
        label="Coach Registration"
        checked={triggers.coachRegistration}
        onChange={() => onToggle("coachRegistration")}
        disabled={loading}
      />
      <TriggerRow
        label="Scout Registration"
        checked={triggers.scoutRegistration}
        onChange={() => onToggle("scoutRegistration")}
        disabled={loading}
      />
      <TriggerRow
        label="Request More Video"
        checked={triggers.requestMoreVideo}
        onChange={() => onToggle("requestMoreVideo")}
        disabled={loading}
      />
    </div>
  </div>
);
